import { Checkbox, FormControlLabel, TextField } from "@mui/material";
import { UploadFormElement } from "../../../types";
import { FormElementChangeType } from "../FormBuilder";

export const UploadSideSectionDisplay = ({
  element,
  onChange,
}: {
  element: UploadFormElement;
  onChange: (props: FormElementChangeType) => void;
}) => {
  return (
    <>
      <TextField
        label="Label Upon Completion"
        value={element.completedLabel}
        onChange={(e) => {
          const newValue = e.target.value;
          onChange({
            changeType: "update",
            newElement: {
              ...element,
              completedLabel: newValue,
            },
          });
        }}
      />

      <TextField
        label="Allowed Types"
        value={element.allowedTypes || ""}
        onChange={(e) => {
          const newValue = e.target.value;
          onChange({
            changeType: "update",
            newElement: {
              ...element,
              allowedTypes: newValue,
            },
          });
        }}
      />

      <FormControlLabel
        control={
          <Checkbox
            onChange={(e) => {
              onChange({
                changeType: "update",
                newElement: {
                  ...element,
                  multiple: e.target.checked,
                },
              });
            }}
            checked={element.multiple}
          />
        }
        label="Allow Multiple Files"
        value={element.multiple}
      />
    </>
  );
};
